module.exports = __webpack_public_path__ + "img/1640.29d8a585.png";